import React from 'react';
import { ConfirmModal } from '../ConfirmModal';
import { Loader } from '../Loader';
import { DialogBox } from '../Dialog';
import { FaxConfirmContent } from './FaxConfirmContent';
import defaults from '../translations/en.json';

var _ref = /*#__PURE__*/React.createElement(Loader, null);

export const FaxModal = ({
  open,
  onClose,
  siteFaxList,
  faxOption,
  setFaxOption,
  onSubmit
}) => /*#__PURE__*/React.createElement(DialogBox, {
  open: open,
  disableBackdropClick: true,
  handleClick: onClose,
  disableScrollLock: true,
  fullWidth: true,
  maxWidth: "xs",
  title: defaults.faxInfo
}, !siteFaxList && _ref, /*#__PURE__*/React.createElement(ConfirmModal, {
  onOKClick: onSubmit,
  okText: defaults.sendFax,
  isOkDisabled: !(faxOption !== null && faxOption !== void 0 && faxOption.recipientnumber) || !(faxOption !== null && faxOption !== void 0 && faxOption.recipientname),
  onCancelClick: () => {
    onClose();
    setFaxOption(null);
  },
  noText: defaults.cancel,
  modalText: "",
  style: {
    width: '100%'
  },
  content: /*#__PURE__*/React.createElement(FaxConfirmContent, {
    siteFaxList: siteFaxList,
    setFaxOption: setFaxOption,
    faxOption: faxOption
  })
}));